import _ from 'lodash';

const useCategories = (categoryIds, allCategories) => _(allCategories).keyBy('id').at(categoryIds).value();

export default useCategories;